
export default function MobileMenu() {
    const openButton = document.querySelector('[rel="js-open-menu"]'),
        closeButton = document.querySelector('[rel="js-close-menu"]'),
        mobileMenu = document.querySelector('[rel="js-mobile-menu"]'),
        deadZone = document.querySelector('[rel="js-dead-zone"]');

    const openMenu = function () {
        mobileMenu.classList.remove('hidden');

        Intercom('hide');

        Intercom('update', {
            hide_default_launcher: true,
        });
    };

    const closeMenu = function () {
        mobileMenu.classList.add('hidden');

        Intercom('update', {
            hide_default_launcher: false,
        });
    };

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);
    deadZone.addEventListener('click', closeMenu);
}



// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/components/mobile-menu.js